import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import VerticalDots from "../../assets/svg/VerticalDots";
import LoaderModal from "../../components/LoaderModal/LoaderModal";
import Pagination from "../../components/Pagination/Pagination";
import SingleNotification from "../../components/SingleNotification/SingleNotification";
import { useUserState } from "../../context/UserContext";
import { useAuthentication } from "../hooks/useAuthentication";
import styles from "./PrimljeneObavijesti.module.css";
import {
  fetchNotifications,
  handleButtonDropdown,
  handleCheckboxChange,
  handleMarkAsReadOrDelete,
  handleToggleSelectAll,
  organizeNotificationsByMonth,
} from "./utils";

function PrimljeneObavijesti() {
  const navigate = useNavigate();
  const { userData, setUserData } = useUserState();
  const { authToken } = useAuthentication();
  const [currentPage, setCurrentPage] = useState(1);
  const [notifications, setNotifications] = useState([]);
  const [selectedNotificationIDs, setSelectedNotificationIDs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dropRef = useRef(null);
  const buttonRef = useRef(null);
  const [buttonDropdown, setButtonDropdown] = useState(false);
  let unreadNotifications;
  let readNotifications;
  let currentOffers;
  let itemsPerPage;
  let readNotificationsArray;
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        buttonRef.current &&
        buttonRef.current.contains(event.target) &&
        dropRef.current
      ) {
        setButtonDropdown(true);
      } else {
        setButtonDropdown(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (authToken) fetchNotifications(userData, authToken, setNotifications);
  }, [authToken, userData]);

  if (notifications?.length > 0) {
    unreadNotifications = notifications?.filter(
      (item) => !item?.readBy?.includes(userData?.id)
    );
    readNotifications = notifications?.filter((item) =>
      item?.readBy?.includes(userData?.id)
    );
    itemsPerPage = 1;
    const readNotificationsByMonth =
      organizeNotificationsByMonth(readNotifications);
    readNotificationsArray = Object.entries(readNotificationsByMonth).map(
      ([monthYearKey, notifications]) => {
        const [month, year] = monthYearKey.split("-");
        return { month, year, notifications };
      }
    );

    currentOffers = readNotificationsArray.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
    if (readNotifications?.length === 0 && unreadNotifications?.length === 0) {
      return (
        <div className={styles.emptyContainer}>
          <span className={styles.emptySpan}>
            Još uvijek nemaš obavijesti.{" "}
          </span>
        </div>
      );
    }
  }

  return (
    <>
      {isLoading ? (
        <LoaderModal />
      ) : (
        <div className={styles.wrapper}>
          <div className={styles.btnRow}>
            <button
              className={styles.saveBtn}
              onClick={() =>
                handleToggleSelectAll(
                  notifications,
                  selectedNotificationIDs,
                  setSelectedNotificationIDs
                )
              }
            >
              Označi sve
            </button>
            <div className={styles.dropdownWrapper}>
              {" "}
              <div
                ref={buttonRef}
                onClick={() =>
                  handleButtonDropdown(setButtonDropdown, buttonDropdown)
                }
                className={styles.moreButton}
              >
                <p className={styles.moreButtonText}>Više</p>
                <VerticalDots className={styles.moreButtonIcon} />
              </div>
              {buttonDropdown && (
                <div className={styles.dropdownContainer}>
                  <div
                    onClick={() =>
                      handleMarkAsReadOrDelete(
                        setIsLoading,
                        selectedNotificationIDs,
                        authToken,
                        setUserData,
                        userData,
                        setNotifications,
                        setSelectedNotificationIDs,
                        "read"
                      )
                    }
                    ref={dropRef}
                    className={
                      selectedNotificationIDs.length === 0
                        ? styles.dropdownItemDisabled
                        : styles.dropdownItem
                    }
                  >
                    <p className={styles.text} style={{ color: "#5f6d7e" }}>
                      Označi kao pročitano
                    </p>
                  </div>
                  <div
                    className={
                      selectedNotificationIDs.length === 0
                        ? styles.dropdownItemDisabled
                        : styles.dropdownItem
                    }
                    onClick={() =>
                      handleMarkAsReadOrDelete(
                        setIsLoading,
                        selectedNotificationIDs,
                        authToken,
                        setUserData,
                        userData,
                        setNotifications,
                        setSelectedNotificationIDs,
                        "delete"
                      )
                    }
                  >
                    <p className={styles.text} style={{ color: "#A8252A" }}>
                      Obriši
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.topTitle}>
            <div className={styles.horizontal} />
            NEPROČITANO
            <div className={styles.horizontal} />
          </div>
          <div className={styles.notificationColumn}>
            {unreadNotifications?.length > 0 ? (
              <div className={styles.unreadColumn}>
                {unreadNotifications?.map((item, index) => (
                  <SingleNotification
                    selectedNotificationIDs={selectedNotificationIDs}
                    item={item}
                    handleCheckboxChange={() =>
                      handleCheckboxChange(
                        selectedNotificationIDs,
                        item.id,
                        setSelectedNotificationIDs
                      )
                    }
                    onClick={() => navigate(`/pojedina-obavijest/${item.id}`)}
                    key={index}
                    isRead={item.readBy?.includes(userData?.id)}
                    createdAt={item.createdAt}
                    fullName={item.fullName}
                    notificationTitle={item.subject}
                    showDate
                    showBorder={index !== unreadNotifications?.length - 1}
                  />
                ))}
              </div>
            ) : (
              <p style={{ width: "100%", textAlign: "center" }}>
                Trenutno nemate nepročitanih obavijesti!
              </p>
            )}
          </div>
          {currentOffers?.map((item, index) => (
            <div className={styles.readColumn} key={index}>
              <div className={styles.topTitle} style={{ marginBottom: 24 }}>
                <div className={styles.horizontal} />
                <div className={styles.date}>
                  {item.month} {item.year}
                </div>
                <div className={styles.horizontal} />
              </div>
              {item.notifications?.map((notification, notificationIndex) => (
                <SingleNotification
                  selectedNotificationIDs={selectedNotificationIDs}
                  onClick={() =>
                    navigate(`/pojedina-obavijest/${notification.id}`)
                  }
                  item={notification}
                  key={notificationIndex}
                  handleCheckboxChange={() =>
                    handleCheckboxChange(
                      selectedNotificationIDs,
                      notification.id,
                      setSelectedNotificationIDs
                    )
                  }
                  isRead={notification?.readBy?.includes(userData?.id)}
                  createdAt={notification?.createdAt}
                  fullName={notification?.fullName}
                  notificationTitle={notification?.subject}
                  showDate
                  showBorder={
                    notificationIndex !== item.notifications?.length - 1
                  }
                />
              ))}
            </div>
          ))}
          <Pagination
            itemsToDisplay={readNotificationsArray}
            setCurrent={setCurrentPage}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            customWidth={"100%"}
          />
        </div>
      )}
    </>
  );
}

export default PrimljeneObavijesti;
